import { memo } from "react";
import { SummaryCard } from "../../../../components/summary-card/summary-card";
import "./content-summary.css";

export const ContentSummary = memo(({ items }) => {
  return (
    <section className="content-summary">

      <div className="content-summary__grid">
        {items.map((item) => (
          <SummaryCard
            key={item.key}
            title={item.title}
            total={item.total}
            icon={item.icon}
            description={item.description}
            meta={item.meta}
            href={item.href}
          />
        ))}
      </div>
    </section>
  );
});